module.exports = __webpack_public_path__ + "img/og-copylink.37acf4a7.svg";